// libraries
import React, { useEffect, useState } from 'react';

import { Button, message } from 'antd';
import Modal from 'react-modal';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { T } from 'react-translator-component';
import styled from 'styled-components';

// styles
import { deleteOcppTag } from '../../../../hooks/ocpptags';
import { COLORS } from '../../../../utils/theme/colors';

interface Props {
  className: string;
  index: number;
  data: any[];
  filteredNotifications: any;
  routes: any;
}

interface ocppTag {
  ocppTagPk: number;
  idTag: string;
  parentIdTag: string;
  parentUserName: string;
  ownerUserPk: number;
  ownerUserName: string;
  isFreeRecharge: boolean;
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const OcppTagCardInnerContent: React.FC<Props> = ({ className, index, data, routes }) => {
  const dispatch = useDispatch();

  const [ocppTagSelected, setOcppTagSelected] = useState<ocppTag | null>(null);
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const handleDelete = async (ocppTagPk) => {
    const data = await deleteOcppTag(ocppTagPk);

    if (data !== null) {
      if (data.type === 'success') {
        message.success('Ocpp Tag successfully deleted!');
        closeModal();
        setTimeout(() => {
          document.location.href = '/ocpptags';
        }, 1000);
      } else {
        message.error('Unable to delete Ocpp Tag.');
      }
    }
  };

  useEffect(() => {
    setOcppTagSelected(data[index]);
  }, [ocppTagSelected, index, data, dispatch]);

  return (
    <Div className={className}>
      <ButtonsWrapper>
        {routes.find(({ path }) => path === '/ocpptags/edit/:id') ? (
          <Link className='button_ocpptag cursor' to={`/ocpptags/edit/${ocppTagSelected?.ocppTagPk}`}>
            <p>{T('Edit Ocpp Tag')}</p>
          </Link>
        ) : null}
        {routes.find(({ path }) => path === '/ocpptags/delete/:id') ? (
          <>
            <button className='button_ocpptag cursor delete_station' onClick={openModal}>
              <p>{T('Delete Ocpp Tag')}</p>
            </button>
            <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles} contentLabel='Example Modal'>
              <h1>
                {T('Delete Ocpp Tag')} {ocppTagSelected?.idTag}
              </h1>
              <p>
                {T(
                  'Are you sure you want to delete this Ocpp Tag? When deleting, all the history already made in it will be lost.',
                )}
              </p>
              <ModalButtonsWrapper>
                <Button type='primary' onClick={closeModal}>
                  {T('Cancel')}
                </Button>
                <Button type='primary' danger onClick={() => handleDelete(ocppTagSelected?.ocppTagPk)}>
                  {T('Delete')}
                </Button>
              </ModalButtonsWrapper>
            </Modal>
          </>
        ) : null}
      </ButtonsWrapper>

      <OcppTagDetailWrapper>
        <div className='field'>
          <p className='strong'>{T('Owner ID')}:</p>
          {ocppTagSelected?.ownerUserPk ? <p>{ocppTagSelected?.ownerUserPk}</p> : <p>{T('Does not own')}</p>}
        </div>
        <div className='field'>
          <p className='strong'>{T('Owner User')}:</p>
          {ocppTagSelected?.ownerUserName ? <p>{ocppTagSelected?.ownerUserName}</p> : <p>{T('Does not own')}</p>}
        </div>

        <div className='field'>
          <p className='strong'>{T('Recarga gratuita')}:</p>

          <p>{ocppTagSelected?.isFreeRecharge ? 'Sim' : 'Não'}</p>
        </div>
      </OcppTagDetailWrapper>
    </Div>
  );
};
const mapStateToProps = (state) => {
  return {
    filteredNotifications: state.notifications.filteredNotifications,
    routes: state.user.routes,
  };
};

export default connect(mapStateToProps)(OcppTagCardInnerContent);

const Div = styled.div`
  display: flex;
  flex-direction: row;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .button_ocpptag {
    margin-top: 6px;
    margin-left: 20px;
    margin-right: auto;
    border-radius: 8px;
    width: 150px;
    padding: 10px 0 10px 0;
    text-align: center;
    text-decoration: none;
    justify-content: space-between;
    font-size: 13px;
    transition: background-color 200ms ease-in-out;
    background-color: rgba(0, 0, 0, 0.05);
    color: #555;

    p {
      margin: 0 0 0 6px;
    }

    :hover path {
      fill: ${COLORS.primary};
    }

    :hover {
      background-color: ${({ theme }) => theme.hoveredDiv};
      color: ${COLORS.primary};
    }
  }

  .delete_station {
    background-color: ${COLORS.red};
    color: ${COLORS.white};

    :hover path {
      fill: #ff7d7d;
    }

    :hover {
      background-color: #ff7d7d;
      color: #ffd6d6;
    }
  }
`;
const ModalButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const OcppTagDetailWrapper = styled.div`
  display: flex;
  margin: 17px 0 0 70px;
  flex-direction: column;

  .field {
    display: flex;
    flex-direction: row;
  }

  .strong {
    font-weight: 600;
    margin-right: 10px;
  }

  p {
    margin: 3px 0;
    font-size: 12px;
    width: max-content;
  }
`;
